import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import TodoComponent from 'modules/users/components/todo';
import Main from 'components/templates/Main';
import {
  todos as todoSelector,
} from 'selectors/user';
import { fetchTodos } from 'actions';

class TodoContainer extends React.Component {
  componentDidMount() {
    this.fetch();
  }

  fetch = () => {
    this.props.fetchTodos();
  }

  render() {
    return (
      <Main
        title={(
          <FormattedMessage
            id="To do list"
            defaultMessage="To do list"
          />
        )}
      >
        <TodoComponent
          todos={this.props.todos}
        />
      </Main>
    );
  }
}

TodoContainer.propTypes = {
  todos: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    }),
  ),
  fetchTodos: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  todos: todoSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchTodos: () => dispatch(fetchTodos()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TodoContainer);
